import _ from "lodash";
import {
  Text,
  Title,
  Divider,
  Group,
  ThemeIcon,
  Badge,
  ActionIcon,
  Tooltip,
} from "@mantine/core";
import React from "react";
import moment from "moment";
import { useEffect, useState } from "react";

import {
  IconClick,
  IconCash,
  IconHear,
  IconCake,
  IconMailbox,
  IconFaceId,
  IconPhone,
  IconLanguage,
  IconFlag,
  IconSchool,
  IconLink,
  IconIdBadge,
  IconBarcode,
} from "@tabler/icons";

import { useServerApi } from "../hooks/userServerApi";
import { useAuthUser } from "react-auth-kit";
import { formatPhoneDisplay } from "../helpers/phoneUtils";
import { useTabNavigate } from "../hooks/useTabNavigate";
import { getEntityTabLabel } from "../utils/tabNavigation";
import { useTranslation } from "react-i18next";

const OrderApplicantDetail = ({
  form,
  name = "client",
  size = "sm",
  ...props
}) => {
  const [client, setClient] = useState();
  const [api] = useServerApi();
  const tabNav = useTabNavigate();
  const { t } = useTranslation();
  let formValue = _.get(form.values, name);

  const auth = useAuthUser();
  const getEntityLink = () => {
    const { userRole } = auth();
    if (!userRole) return null;

    const roleLink = userRole.entityLinks?.find((l) => l.entity === "client");
    if (!roleLink || !roleLink.link) return null;

    return roleLink.link;
  };

  const entityLink = getEntityLink();
  const professionalInvestor = form?.values?.professionalInvestor;
  const mainlandChineseVisitor = form?.values?.mainlandChineseVisitor;

  useEffect(() => {
    typeof formValue === "object"
      ? setClient(formValue)
      : fetchClient(formValue);
  }, [formValue]);

  const fetchClient = async (clientId) => {
    if (!clientId) return;
    let client = await api.getById({ apiEntity: "client", id: clientId });
    setClient(client);
  };

  const ClientInfo = ({ client }) => {
    const {
      name,
      cname,
      status,
      vulnerable,
      orders,
      email,
      phone,
      address,
      language,
      id,
      idType,
      educationLevel,
      birthday,
      residentialCountry,
      placeOfBirth,
      code,
      contactPerson,
    } = client;

    const iconSize = 18;

    return (
      <>
        {code && (
          <Group mt={10} noWrap>
            <IconBarcode size={iconSize} />
            <Text size={size} weight={500} transform="uppercase">
              {code}
            </Text>
            {entityLink && (
              <ActionIcon
                size="xs"
                onClick={() =>
                  tabNav.openDetail({
                    pathname: entityLink,
                    id: client._id,
                    mode: "edit",
                    label: getEntityTabLabel(client, client._id, "client"),
                  })
                }
              >
                <IconLink />
              </ActionIcon>
            )}
          </Group>
        )}

        <Group mt={10} noWrap align="flex-start">
          <IconFaceId size={iconSize} style={{ flexShrink: 0 }} />
          {name && (
            <Text size={size} weight={500} transform="capitalize">
              {name}
            </Text>
          )}
        </Group>

        {cname && (
          <Group mt={10} noWrap>
            <IconLanguage size={iconSize} />
            <Text size={size} weight={500}>
              {cname}
            </Text>
          </Group>
        )}

        {id && (
          <Group mt={10} noWrap>
            <IconBarcode size={iconSize} />
            <Text size={size} weight={500} transform="uppercase">
              {id}
            </Text>
          </Group>
        )}
        {contactPerson && (
          <Group mt={10} noWrap>
            <IconPhone size={iconSize} />
            <Text size={size} weight={500} transform="capitalize">
              {contactPerson}
            </Text>
          </Group>
        )}

        {email && (
          <Group mt={10} noWrap>
            <IconMailbox size={iconSize} />
            <Text size={size} weight={500} transform="lowercase">
              {email}
            </Text>
          </Group>
        )}

        {formatPhoneDisplay(phone) && (
          <Group mt={10} noWrap>
            <IconPhone size={iconSize} />
            <Text size={size} weight={500} transform="lowercase">
              {formatPhoneDisplay(phone)}
            </Text>
          </Group>
        )}

        {language && (
          <Group mt={10} noWrap>
            <IconLanguage size={iconSize} />
            <Text size={size} weight={500} transform="capitalize">
              {language}
            </Text>
          </Group>
        )}

        {placeOfBirth && (
          <Group mt={10} noWrap>
            <IconFlag size={iconSize} />
            <Text size={size} weight={500} transform="capitalize">
              {placeOfBirth}
            </Text>
          </Group>
        )}

        {educationLevel && (
          <Group mt={10} noWrap>
            <IconSchool size={iconSize} />
            <Text size={size} weight={500} transform="capitalize">
              {educationLevel}
            </Text>
          </Group>
        )}

        {birthday && moment(birthday).isValid() && (
          <Group mt={10} noWrap>
            <IconCake size={18} />
            <Text size={size} weight={500}>
              {moment(birthday).format("LL")}
            </Text>
          </Group>
        )}
      </>
    );
  };

  return (
    <>
      {(professionalInvestor || mainlandChineseVisitor) && (
        <Group spacing={4} mb="sm">
          {professionalInvestor && (
            <Tooltip label={t("Professional Investor (PI)")}>
              <Badge size="xs" color="yellow" radius={0}>
                PI
              </Badge>
            </Tooltip>
          )}
          {mainlandChineseVisitor && (
            <Tooltip label={t("Mainland Chinese Visitor (MCV)")}>
              <Badge size="xs" color="orange" radius={0}>
                MCV
              </Badge>
            </Tooltip>
          )}
        </Group>
      )}
      {client && <ClientInfo client={client} />}
    </>
  );
};

export default OrderApplicantDetail;
